import type { QueryHookOptions } from "@apollo/client";
import { useQuery, gql } from "@apollo/client";

import type { CatalogProductMasterVariantClinic } from "@clinic/shared/data/splinters";
import { CATALOG_PRODUCT_MASTER_VARIANT_CLINIC } from "@clinic/shared/data/splinters";
import type { ProductSearchParams } from "@shared/components/CatalogSearch";
import type { PageInfoFragment } from "@shared/data/fragments";
import { PAGE_INFO_FRAGMENT } from "@shared/data/fragments";

const GET_PRODUCT = gql`
  query ProductSearch_ClinicShared_Query(
    $query: String
    $typeaheadSelectionId: ID
    $first: Int
    $after: String
    $sort: [ProductSearchSort!]
    $filters: ProductSearchV2FilterObject
  ) {
    viewer {
      productSearchV2(
        query: $query
        typeaheadSelectionId: $typeaheadSelectionId
        first: $first
        after: $after
        sort: $sort
        filters: $filters
      ) {
        nodes {
          ...CatalogProductMasterVariantClinic
        }
        pageInfo {
          ...PageInfoFragment
        }
        totalCount
      }
    }
  }
  ${CATALOG_PRODUCT_MASTER_VARIANT_CLINIC}
  ${PAGE_INFO_FRAGMENT}
`;

interface ProductSearchData {
  viewer: {
    productSearchV2: {
      nodes: CatalogProductMasterVariantClinic[];
      pageInfo: PageInfoFragment;
      totalCount: number;
    };
  };
}

interface ProductSearchVariables extends ProductSearchParams {
  first?: number;
  after?: string;
}

const defaultOptions: QueryHookOptions<ProductSearchData, ProductSearchVariables> = {
  variables: {
    first: 24,
    filters: {
      onlyIngredient: false,
    },
  },
};

const useProductSearchQuery = (
  options?: QueryHookOptions<ProductSearchData, ProductSearchVariables>
) => {
  return useQuery<ProductSearchData, ProductSearchVariables>(GET_PRODUCT, {
    ...defaultOptions,
    ...options,
    variables: { ...defaultOptions.variables, ...options.variables },
  });
};

export type { ProductSearchVariables, ProductSearchData };
export { useProductSearchQuery, GET_PRODUCT, defaultOptions as ProductSearchQueryDefaultOptions };
